// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_fg-a";
export var fulfillmentFormRail = "_fg-9";
export var headerTitleRow = "_fg-c";
export var orderDetailsWrapper = "_fg-7";
export var orderLinkTrigger = "_fg-2";
export var paymentInformationGrid = "_fg-h";
export var paymentSummaryColumn = "_fg-i";
export var shipmentContainer = "_fg-b";
export var shipmentDetailsMainPane = "_fg-8";
export var shipmentNavigationCard = "_fg-5";
export var shipmentNavigationRail = "_fg-3";
export var shipmentNavigationRailHeader = "_fg-4";
export var shipmentSummaryFact = "_fg-e";
export var shipmentSummaryGrid = "_fg-d";
export var shipmentSummaryMetadataRow = "_fg-f";
export var shipmentSummaryTags = "_fg-g";
export var shipmentWorkspace = "_fg-0";
export var shipmentWorkspaceContent = "_fg-6";
export var shipmentWorkspaceHeader = "_fg-1";